// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { spinner } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-spinner': IconSpinner;
    }
}

/**
 * The icon component for the 'spinner' icon
 */
export class IconSpinner extends IconSvg {
    public constructor() {
        super(spinner);
    }
}

registerIconSvg('icon-spinner', IconSpinner);
export const iconSpinnerTag = 'nimble-icon-spinner';
